import { IProductQuestionEntity } from '../../entitites/productQuestion.entity';
import { AnswerDto } from './question.dto';

export class ProductQuestionDto {
  readonly guid: string;
  readonly reference: string;
  readonly title: string;
  readonly content: string;
  readonly phrasing: string;
  readonly icon: string;
  readonly answer: AnswerDto;
  readonly options: Array<{
    readonly value: string;
    readonly label: string;
  }>;
  readonly replacements: Array<{
    readonly replaceThis: string;
    readonly replaceWith: string;
  }>;
  readonly isAnswered: boolean;
  readonly inputType:
    | 'text'
    | 'number'
    | 'money'
    | 'radio'
    | 'date'
    | 'switch'
    | 'toggle_group'
    | null;
  readonly moreInformation: string;
  readonly isRequired: boolean;
  readonly isEditable: boolean;
  readonly revalidateOnChange: boolean;

  constructor(params: IProductQuestionEntity) {
    this.guid = params.guid;
    this.reference = params.reference;
    this.title = params.title;
    this.content = params.content;
    this.phrasing = params.phrasing;
    this.icon = params.icon;
    this.answer = new AnswerDto(params.answer);
    this.options = params.options;
    this.replacements = params.replacements.map((replacement) => ({
      replaceThis: replacement.replace_this,
      replaceWith: replacement.replace_with,
    }));
    this.isAnswered = params.is_answered;
    this.inputType = params.input_type;
    this.moreInformation = params.more_information;
    this.isRequired = params.is_required;
    this.isEditable = params.is_editable;
    this.revalidateOnChange = params.revalidate_on_change ?? false;
  }
}
